import schemas from '../fields/definedSchemas';

const fields = {
    endorsement_text: {
        ...schemas.textRequired,
        label: "What endorsements you would like to apply for? Enter the endorsements you're hoping for!",
        section: 'Endorsements',
        multiline: true,
        minRows: 5,
        variant: 'outlined',
    },
    ssn: {
        ...schemas.textRequired,
        label: 'What is your Social Security Number? (format 000-00-0000)',
        section: 'Endorsements',
    },
    height_feet: {
        ...schemas.integerRequired,
        label: 'feet',
        section: 'Endorsements',
    },
    height_inches: {
        ...schemas.integerRequired,
        label: 'inches',
        section: 'Endorsements',
    },
    weight: {
        ...schemas.integerRequired,
        label: 'pounds',
        section: 'Endorsements',
    },
    sex: {
        ...schemas.radioRequired,
        label: 'What gender do you identify as?',
        section: 'Endorsements',
        options: {male: 'Male', female: 'Female'},
    },
};

export default fields;
